import React from 'react';
import $ from 'jquery';
import {
	CommonValue,
} from '@/utils/Tools';

export default class BaseClass extends React.Component
{
	constructor(props)
	{
		super(props);
		this.config={
		};
	}
	
	focusError(isModal)
	{
		window.setTimeout(()=>{
			if(!isModal)
			{
				let node = $('.ant-form-item-has-error:eq(0)');
				let offset = node.offset();
				$('html ,body').animate({scrollTop: offset.top - 10}, 300,()=>{
					if(node.find('.ant-input').length)
						node.find('.ant-input').trigger('focus');
				});
				//$(window).scrollTop(offset.top - 10);
			}
			else
			{
				let wrap = $('.ant-modal-wrap');
				let node = wrap.find('.ant-form-item-has-error:eq(0)');
				
				let offset = node.offset();
				//let wrapOffset = $('#page-wrapper').offset();
				let wrapOffset = wrap.offset();
				let wrapScrollTop = wrap.scrollTop();
				//wrap.animate({scrollTop: wrapScrollTop + (offset.top - wrapOffset.top) - 20}, 200,()=>{
				wrap.animate({scrollTop: wrapScrollTop + (offset.top - wrapOffset.top) - 20}, 200,()=>{
					if(node.find('.ant-input').length)
						node.find('.ant-input').trigger('focus');
				});
			}
		},100);
	}
	
	/*
	setFieldValue(key,value)
	{
		let data = {};
		data[key] = value;
		this.formRef && this.formRef.setFieldsValue(data);
	}
	*/
	
	changeInfo(key,value,model)
	{
		if(!model) model='info';
		
		let info=this.state[model];
		if(value != null)
			info[key]=value;
		else
			delete(info[key]);
		
		let obj={};
		obj[model]=info
		this.setState(obj);
	}
}
